import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {InfoPrice, InfoPriceNum, InfoPriceTag} from "./style";
import {observer} from "mobx-react";
import {targetAllStatus, getStatusTarget} from "../../../utils/status";
import { getPriceAndUnit } from '../../../utils/tool';

@observer
class PriceItem extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  renderPriceTag() {
    let priceTag = '当前价';
    const {auctionStatus} = this.props.realTimeData ? this.props.realTimeData : {};
    switch (auctionStatus) {
      case 1:
        priceTag = '当前价';
        break;
      case 2:
        priceTag = '当前价';
        break;
      case 0:
        priceTag = '起始价';
        break;
    }
    return <InfoPriceTag>{priceTag}：</InfoPriceTag>
  }

  renderPriceNum() {
    // const {auctionStatus, currentPriceWithUnit, separateDispose, disposeTotalUnit} = this.props.realTimeData ? this.props.realTimeData : {};
    // const isDisposedProduct = separateDispose === 1 && disposeTotalUnit;
    const { displayStatus, auctionStatus, currentPrice, disposeTotalUnit } = this.props.realTimeData ? this.props.realTimeData : {};
    let status = targetAllStatus[getStatusTarget(displayStatus, auctionStatus)];
    return <InfoPriceNum color={status.fontColor}>￥{getPriceAndUnit(currentPrice, disposeTotalUnit)}</InfoPriceNum>
  }

  render() {
    const {currentPrice} = this.props.realTimeData ? this.props.realTimeData : {};

    return (
      !!currentPrice
        ? <InfoPrice>
          {this.renderPriceTag()}
          {this.renderPriceNum()}
        </InfoPrice>
        : <InfoPrice />
    )
  }
}

export default PriceItem;
